var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 6.60928C0.5 2.95908 3.45908 0 7.10928 0C10.7595 0 13.7186 2.95908 13.7186 6.60928C13.7186 10.2595 10.7595 13.2186 7.10928 13.2186C3.45908 13.2186 0.5 10.2595 0.5 6.60928ZM7.10928 1.69472C4.39505 1.69472 2.19472 3.89505 2.19472 6.60928C2.19472 9.32352 4.39505 11.5238 7.10928 11.5238C9.82352 11.5238 12.0238 9.32352 12.0238 6.60928C12.0238 3.89505 9.82352 1.69472 7.10928 1.69472Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5842 10.0841C10.9151 9.75319 11.4516 9.75323 11.7825 10.0842L16.2513 14.5536C16.5822 14.8845 16.5821 15.421 16.2512 15.7519C15.9203 16.0828 15.3838 16.0828 15.0529 15.7518L10.5841 11.2824C10.2532 10.9515 10.2532 10.415 10.5842 10.0841Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.f3731bd723465f053c578db821f1694b.svg";
export { ForwardRef as ReactComponent };